export default "__VITE_ASSET__r240x7l___"